import { trigger, transition, animate, style, state } from '@angular/animations';

export const notificationsCardCollapseAnimation = trigger('cardCollapse', [
    state('uncollapse', style({
        backgroundColor: 'red'
    })),
    state('collapse', style({
        backgroundColor: 'blue'
    })),
    transition('collapse => uncollapse', [
      animate('2s')
    ]),
    transition('uncollapse => collapse', [
      animate('2s')
    ]),
  ]);
